export const FEE = 0.13; // 13% fee
// export const FEE = 0.08; // 8% fee during lorettas sale
